/*globals $*/
(function(BDM, careerImpact) {
    'use strict';

    var settings = {
            defaultZip: 90802,
            dataurl: "career_impact.json",
            shownumber: 100 /// Number of results to reveal initially and after load more
        },

        $el = { //stored elements
            container: $('.career-impact'),
            finder: $('.career-impact .location__field'),
            locationEdit: $('.career-impact .location__edit-window'),
            locationField: $('#impactzipcode'),
            notfound: $('.career-impact__campus--notfound'),
            location: $('.career-impact__location--name'),
            locationLink: $('.career-impact__locations-link'),
            jobstotal: $('.career-impact__jobs-total'),
            organizations: $('.career-impact__organizations'),
            table: $('.career-impact__table table'),
            loading: $('.icon__loading'),
        },
        odometer,
        zipcode,
        results = [],
        defaultResults = [],
        resultsLoading = false,
        hasLoaded = false,
        defaultLoaded = false,
        loadDefault = false;
    /**
     *   Helper Methods
     **/

    function showResults() {
        var row,
            displayResults = results;
        
        let zipcodeLocal = window.localStorage.getItem('z');
        let countryLocal = window.localStorage.getItem('country');
        if (displayResults && !displayResults.openings) {
            displayResults = defaultResults;
            $el.locationEdit.addClass('has-error has-error__nodata');

            if (defaultResults.openings && defaultResults.openings > 0) {
                $('.forms__message--nodata').find('.default').text(defaultResults.location);
            }
            loadDefault = true;
            resultsLoading = false;
            loadData();
        }
        if (zipcodeLocal === "" || !displayResults.openings){
            $el.locationEdit.addClass('has-error has-error__nodata');
            loadDefault = true;
            resultsLoading = false;
            loadData();
        }
        if (zipcodeLocal !== "" && countryLocal === 'United States'){
            $el.locationEdit.removeClass('has-error has-error__nodata');
        }
        if (displayResults.openings && displayResults.openings > 0) {
            hasLoaded = true;
            $el.jobstotal.attr('data-value', displayResults.openings);
            if ($el.container.hasClass('reached')) {
                $el.container.addClass('onscreen');
                $el.container.find('.career-impact__jobs-outer').addClass('animate');
                $el.jobstotal.find('span').text($el.jobstotal.attr('data-value'));
            }
            $el.container.addClass('ready');
            $el.location.text(displayResults.location);
            $el.organizations.html('');
            if (displayResults.organizations && displayResults.organizations.length) {
                displayResults.organizations.forEach(function(result, index) {
                    $el.organizations.append('<li>' + result.name + '</li>');
                });
            }
            $el.table.find('tbody').html('');
            if (displayResults.related && displayResults.related.length) {
                displayResults.related.forEach(function(result, index) {
                    var icon = parseFloat(result.growth.slice(0, -1)) > 0 ? "" : "down";
                    row = '<td>' + result.career + '</td><td><span class="icon icon__growth ' + icon + '" aria-hidden="true"></span><strong>' + result.growth + '</strong></td></td><td>' + result.salary + '</td>';
                    $el.table.find('tbody').append('<tr>' + row + '</tr>');
                });
            }
            $('.career-impact__jobs-data').each(function(index, element) {
                var value = $(element).find('.career-impact__jobs-total').attr('data-value'),
                    prepare = $(element).find('.career-impact__prepare').text(),
                    openings = $(element).find('.career-impact__openings').text();
                $(element).attr('aria-label', prepare + ' ' + value + ' ' + openings);
            });
        } else {
            $el.locationEdit.addClass('has-error has-error__nodata');
            if (defaultLoaded === false) {
                loadDefault = true;
                resultsLoading = false;
                loadData();
            }
        }
    }

    function loadData() {
        if (resultsLoading === false) {
            resultsLoading = true;
            $el.container.removeClass('loaded');
            if ($el.container.hasClass('onscreen')) {
                $el.container.removeClass('onscreen').addClass('reached');
            }
            $el.container.find('.career-impact__jobs-outer').removeClass('animate');
            if (zipcode !== $el.finder.val() || loadDefault === true) {
                if (loadDefault === true) {
                    defaultLoaded = true;
                    loadDefault = false;
                    zipcode = settings.defaultZip;
                } else {
                    zipcode = $el.finder.val();
                }
                $.ajax({
                    type: 'POST',
                    url: settings.dataurl,
                    data: { zipcode: zipcode, pathwayid: $el.container.attr('data-pathwayid') },
                    dataType: 'json',
                    success: function(data) {
                        if (loadDefault) {
                            results = [];
                            defaultResults = data.career;
                        } else {
                            if (defaultResults.length === 0) {
                                defaultLoaded = true;
                                defaultResults = data.career;
                            }
                            results = data.career;
                        }
                        $el.container.addClass('loaded');

                        showResults();
                    }
                });
                zipcode = $el.finder.val();
            }
        }
    }

    /// Setup Events
    function bindEvents() {
        odometer = new Odometer({
            el: $el.jobstotal.find('span')[0],
            duration: 2000,
            animation: 'count'
        });
        if ($el.locationEdit.length) {
            $el.locationEdit.on("click",function(event) {
                event.preventDefault();
                if ($el.locationEdit.hasClass('active')) {
                    if (/^([0-9]{5,})$/.test($el.finder.val()) && $el.finder.val() !== zipcode) {
                        resultsLoading = false;
                        loadData();
                    }
                }
            });
        }
        if ($el.finder.length) {
            $el.finder.keydown(function(event) {
                if (event.keyCode === 13) {
                    if (/^([0-9]{5,})$/.test($el.finder.val()) && $el.finder.val() !== zipcode) {
                        resultsLoading = false;
                        loadData();
                    }
                }
            });
            $el.finder.change(function(event) {
                if (/^([0-9]{5,})$/.test($el.finder.val()) && $el.finder.val() !== zipcode) {
                    resultsLoading = false;
                    loadData();
                }
            });
            setTimeout(function() {
                $el.finder.change();
                $el.loading.addClass('fadeout');
            }, 1000);
        }
    }

    /**
     *   Public Methods
     **/

    careerImpact.start = function() {
        if ($el.finder.val()) {
            settings.defaultZip = $el.finder.val();
        }
    };

    careerImpact.init = function() {
        if ($el.finder.length) {
            settings.dataurl = $el.container.attr('data-programsurl') || settings.dataurl;
            bindEvents();
        }
    };
})(
    window.BDM = window.BDM || {},
    window.BDM.careerImpact = window.BDM.careerImpact || {}
);

//load when ready
$(function() {
    window.BDM.careerImpact.init();
});

window.BDM.careerImpact.start();